export function maskCnpj(value: string): string {
  return value.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, "$1.$2.$3$4-$5");
}

export function formatNumberLocal(number: number): string {
  return new Intl.NumberFormat("pt-BR").format(number);
}
